import { BookingPeriod } from '@spiaggeit/spit-datepicker'
import { cn } from '@spiaggeit/spit-ui'
import { t } from 'i18next'
import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'
import { generatePath, Link } from 'react-router-dom'

import { licenseSlice } from '@/store/licenseSlice'
import {
  CHOOSE_PRODUCT_PATH,
  INSERT_DATA_PATH,
  INSERT_INSURANCE_PATH,
  INSERT_PERIOD_PATH,
  MAP_PATH,
  SECTOR_PATH,
  TICKETS_PATH,
} from '../../app/router/paths'
import { Calendar } from '../../assets/icons/Calendar'
import { useAppSelector } from '../../hooks/store'
import { useCurrentPath } from '../../hooks/useCurrentPath'
import {
  bookingPeriodSelector,
  insertPeriodSlice,
} from '../../store/insertPeriodSlice'

export function InsertPeriodLink(props: { className?: string }) {
  const license = useAppSelector(licenseSlice.selectors.license)
  const period = useAppSelector(insertPeriodSlice.selectors.period)
  const bookingPeriod = useAppSelector(bookingPeriodSelector)

  const { i18n } = useTranslation()

  const { currentPath } = useCurrentPath()

  if (
    !license ||
    !period ||
    ![
      CHOOSE_PRODUCT_PATH,
      INSERT_INSURANCE_PATH,
      INSERT_DATA_PATH,
      TICKETS_PATH,
      SECTOR_PATH,
      MAP_PATH,
    ].includes(currentPath)
  ) {
    return null
  }

  const startDateTime = DateTime.fromISO(period.start, {
    locale: i18n.language,
    zone: 'utc',
  })

  const endDateTime = DateTime.fromISO(period.end, {
    locale: i18n.language,
    zone: 'utc',
  })

  const arePeriodsEqual = period?.end === period?.start
  const areMonthsEqual = startDateTime.month === endDateTime.month

  let startDateFormat = 'dd'

  if (arePeriodsEqual || !areMonthsEqual) {
    startDateFormat = 'dd MMM'
  }

  const startDate = startDateTime.toFormat(startDateFormat)
  const endDate = arePeriodsEqual ? null : endDateTime.toFormat('dd MMM')
  const isBookingPeriodHalfDay =
    bookingPeriod === BookingPeriod.MORNING ||
    bookingPeriod === BookingPeriod.AFTERNOON
  const dateString = endDate ? `${startDate} - ${endDate}` : startDate
  const bookingPeriodString = t(`datepicker.bookingPeriod.${bookingPeriod}`)

  return (
    <Link
      className={cn(
        'flex shrink-0 select-none items-center gap-2 text-nowrap rounded-sm border bg-white px-3 py-2 text-sm font-bold text-primary transition-colors hover:border-gray-300',
        props.className
      )}
      to={`${generatePath(INSERT_PERIOD_PATH, {
        license: license.license,
      })}`}
    >
      <Calendar className="size-5" />
      {isBookingPeriodHalfDay
        ? `${dateString} · ${bookingPeriodString}`
        : dateString}
    </Link>
  )
}
